/* __next_internal_client_entry_do_not_use__ default auto */ import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey('da03542248a5d0d0925cb10b2895d127Tz0xMTk3MzMsRT0xNzkwNjM5OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
function MuiXLicense() {
    return null;
}
export default MuiXLicense;
